import { useEffect, useRef } from 'react';
import * as ObjectUtils from './objectUtils';

export function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export function usePrevious(value) {
    // Mimic componentDidUpdate function as in class component
    const ref = useRef();

    useEffect(() => {
        if (typeof value === 'object') {
            ref.current = ObjectUtils.deepCopy(value);
        } else {
            ref.current = value;
        }
    });

    // Note: The value passed to the ref will be assigned only after the component has rendered.
    return ref.current;
}

export const compose = (hocs) => (innerComponent) =>
    hocs.reduceRight((component, hoc) => hoc(component), innerComponent);
